type Sac = {
  whatsapp: string;
  phone: string;
  portalLink: string;
  portalName: string;
};

export type Brand = {
  short: string;
  sac: Sac & {
    hours: {
      whatsapp: string;
      phone: string;
      portal: string;
    };
  };
};

export const enum BusinessUnit {
  EUD = 'eud',
  BOT = 'bot',
}
